import { lazy } from "react";
import type { AppModule } from "../types";
import de from "./i18n/de.json";
import en from "./i18n/en.json";
import fr from "./i18n/fr.json";
import ru from "./i18n/ru.json";

const WikiPage = lazy(() => import("./WikiPage").then((m) => ({ default: m.WikiPage })));

export const wikiModule: AppModule = {
  id: "wiki",
  hasBackend: true,
  nav: { i18nKey: "modules.wiki.nav", group: "data" },
  routes: [{ path: "/wiki", Component: WikiPage }],
  i18n: { de, en, fr, ru },
};
